import { useState, useEffect, useRef } from 'react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
import Layout from '../../components/Layout'
import api from '../../services/api'
import { API_ENDPOINTS } from '../../config/api'
import { searchByUsername } from '../../services/api'
import loaderGif from '../../assets/loader.gif'
import './style.css'

// Table columns — server (reportsController.getUserRegisterDetail) isi shape me rows deta hai
const COLUMNS = [
  ['username', 'User Name'],
  ['agentName', 'Agent Name'],
  ['createdDate', 'Created Date'],
  ['lastLogin', 'Last Login'],
  ['firstDepositDate', 'First Deposit Date'],
  ['lastDepositDate', 'Last Deposit Date'],
  ['deposit', 'Deposit'],
  ['sportsBalance', 'Sports Balance'],
  ['casinoBalance', 'Casino Balance'],
  ['thirdPartyCreditBalance', 'Third Party Credit Balance'],
  ['sportBookBalance', 'Sport Book Balance'],
]
const NUM_KEYS = new Set(['sportsBalance', 'casinoBalance', 'thirdPartyCreditBalance', 'sportBookBalance'])

// Font Awesome 5 ke file-excel / file-pdf glyphs (original panel FA5 use karta hai; apna bundle FA7 hai
// jisme file-pdf ka shape alag hai) — isliye SVG inline.
const ExcelIcon = () => (
  <svg viewBox="0 0 384 512" width="13" height="15" fill="currentColor" aria-hidden="true">
    <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.9c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z" />
  </svg>
)
const PdfIcon = () => (
  <svg viewBox="0 0 384 512" width="13" height="15" fill="currentColor" aria-hidden="true">
    <path d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z" />
  </svg>
)

/**
 * UserRegisterDetail Component
 *
 * Reports → User Register Detail (downline panels par User Bet History ki jagah).
 * Login user ki hierarchy ke saare players — register date / last login ke hisaab se,
 * optional client filter (staff username dene par uski downline ke players).
 * API: GET /admin/reports/user-register-detail?type=&username=&page=&limit=
 */
function UserRegisterDetail() {
  // '1' = All, '2' = Created Date, '3' = Last Login Date — server sirf '3' par last-login sort karta hai,
  // baaki sab par created date desc (All aur Created Date ka result same aata hai)
  const [typeVal, setTypeVal] = useState('1')
  const [clientSearch, setClientSearch] = useState('')
  const [selectedUsername, setSelectedUsername] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const suggestionsRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [tableSearch, setTableSearch] = useState('')
  const [entriesPerPage, setEntriesPerPage] = useState(25)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(e.target)) {
        setShowSuggestions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Page khulte hi + entries badalne par load
  useEffect(() => {
    fetchData(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entriesPerPage])

  const handleClientSearchChange = async (e) => {
    const val = e.target.value
    setClientSearch(val)
    setSelectedUsername('')
    if (val.length >= 2) {
      try {
        const res = await searchByUsername(val, 1, 15)
        const results = res?.data?.results || res?.data || []
        setSuggestions(results)
        setShowSuggestions(results.length > 0)
      } catch {
        setSuggestions([])
        setShowSuggestions(false)
      }
    } else {
      setSuggestions([])
      setShowSuggestions(false)
    }
  }

  const selectClient = (username) => {
    setClientSearch(username)
    setSelectedUsername(username)
    setShowSuggestions(false)
    setSuggestions([])
  }

  const fetchData = async (page = 1) => {
    setLoading(true)
    setErrorMsg('')
    try {
      const params = { type: typeVal, page, limit: entriesPerPage }
      const username = (selectedUsername || clientSearch || '').trim()
      if (username) params.username = username

      const response = await api.get(API_ENDPOINTS.REPORTS.USER_REGISTER_DETAIL, { params })
      if (response.data && response.data.success) {
        setTableData(response.data.data || [])
        const pg = response.data.pagination || {}
        setTotalPages(pg.totalPages || 1)
        setCurrentPage(pg.page || page)
      } else {
        setTableData([])
        setTotalPages(1)
      }
    } catch (error) {
      console.error('Error loading user register detail:', error)
      setErrorMsg(error?.response?.data?.message || 'Failed to fetch user register detail')
      setTableData([])
      setTotalPages(1)
    } finally {
      setLoading(false)
    }
  }

  const handleLoad = (e) => {
    e?.preventDefault()
    fetchData(1)
  }

  const handleReset = (e) => {
    e?.preventDefault()
    setTypeVal('1')
    setClientSearch('')
    setSelectedUsername('')
    setTableSearch('')
    setErrorMsg('')
  }

  // Original balance ko plain number dikhata hai ("0", "150.5"), fixed 2 decimal nahi
  const formatNum = (val) => {
    const n = parseFloat(val)
    if (Number.isNaN(n)) return '0'
    return Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100)
  }

  const cellValue = (row, key) => {
    if (NUM_KEYS.has(key)) return formatNum(row[key])
    const v = row[key]
    return v === null || v === undefined || v === '' ? '-' : String(v)
  }

  // Client-side filter — sirf current page par
  const filteredData = tableSearch
    ? tableData.filter((row) =>
        Object.values(row).some((v) =>
          String(v ?? '').toLowerCase().includes(tableSearch.toLowerCase())
        )
      )
    : tableData

  const exportHead = COLUMNS.map(([, label]) => label)
  const exportRows = () => filteredData.map((row) => COLUMNS.map(([key]) => cellValue(row, key)))

  const handleExportExcel = () => {
    const ws = XLSX.utils.aoa_to_sheet([exportHead, ...exportRows()])
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'User Register Detail')
    XLSX.writeFile(wb, 'user_register_detail.xlsx')
  }

  const handleExportPDF = () => {
    const doc = new jsPDF('landscape')
    doc.setFontSize(14)
    doc.text('User Register Detail', 14, 15)
    autoTable(doc, {
      head: [exportHead],
      body: exportRows(),
      startY: 20,
      styles: { fontSize: 7 },
      headStyles: { fillColor: [44, 62, 80] },
    })
    doc.save('user_register_detail.pdf')
  }

  const hasData = filteredData.length > 0

  return (
    <Layout title="User Register Detail - Diamond Admin">
      {loading && (
        <div
          style={{
            display: 'block',
            position: 'fixed',
            zIndex: 9999,
            backgroundImage: `url(${loaderGif})`,
            backgroundColor: '#666',
            opacity: 0.4,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
            backgroundSize: '100px 100px',
          }}
        />
      )}
      <div className="listing-grid urd-page">
        <div className="account-list-statement">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">User Register Detail</h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="report-form mb-3">
                    <form method="post" className="ajaxFormSubmit" onSubmit={handleLoad}>
                      <div className="d-flex align-items-end flex-wrap" style={{ gap: '10px' }}>
                        {/* Client search (downline only) */}
                        <div style={{ width: '240px' }}>
                          <div className="form-group mb-0" style={{ position: 'relative' }} ref={suggestionsRef}>
                            <label htmlFor="urd-client" className="mb-1" style={{ fontSize: '14px' }}>
                              Search By Client Name
                            </label>
                            <input
                              id="urd-client"
                              type="text"
                              className="form-control"
                              placeholder="Select option"
                              autoComplete="off"
                              style={{ height: '32px', fontSize: '13px' }}
                              value={clientSearch}
                              onChange={handleClientSearchChange}
                              onFocus={() => { if (suggestions.length > 0) setShowSuggestions(true) }}
                            />
                            {showSuggestions && suggestions.length > 0 && (
                              <ul
                                style={{
                                  position: 'absolute',
                                  zIndex: 1000,
                                  background: '#fff',
                                  border: '1px solid #ddd',
                                  borderRadius: 4,
                                  maxHeight: 200,
                                  overflowY: 'auto',
                                  width: '100%',
                                  listStyle: 'none',
                                  padding: 0,
                                  margin: 0,
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                }}
                              >
                                {suggestions.map((s, i) => (
                                  <li
                                    key={s.user_id || s.staff_id || s.wallet_id || i}
                                    style={{
                                      padding: '8px 12px',
                                      cursor: 'pointer',
                                      fontSize: '13px',
                                      borderBottom: '1px solid #eee',
                                    }}
                                    onMouseDown={() => selectClient(s.username)}
                                  >
                                    {s.username} {s.user_type ? `(${s.user_type})` : ''}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>

                        {/* Type */}
                        <div style={{ width: '240px' }}>
                          <label className="mb-1" style={{ fontSize: '14px' }}>Type</label>
                          <select
                            className="form-control"
                            style={{ height: '32px', fontSize: '13px' }}
                            value={typeVal}
                            onChange={(e) => setTypeVal(e.target.value)}
                          >
                            <option value="1">All</option>
                            <option value="2">Created Date</option>
                            <option value="3">Last Login Date</option>
                          </select>
                        </div>

                        <div className="d-flex" style={{ gap: '6px' }}>
                          <button type="submit" className="btn btn-primary px-3" style={{ height: '32px', borderRadius: '4px', fontSize: '13px', lineHeight: 1 }}>
                            Load
                          </button>
                          <button type="button" className="btn btn-light px-3" onClick={handleReset} style={{ height: '32px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px', lineHeight: 1 }}>
                            Reset
                          </button>
                          <button
                            type="button"
                            className={`btn urd-btn urd-btn-excel${hasData ? '' : ' disabled'}`}
                            disabled={!hasData}
                            onClick={handleExportExcel}
                            title="Export to Excel"
                          >
                            <ExcelIcon />
                          </button>
                          <button
                            type="button"
                            className={`btn urd-btn urd-btn-pdf${hasData ? '' : ' disabled'}`}
                            disabled={!hasData}
                            onClick={handleExportPDF}
                            title="Export to PDF"
                          >
                            <PdfIcon />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  {errorMsg && (
                    <div className="alert alert-warning py-2 mb-2" style={{ fontSize: '13px' }}>
                      {errorMsg}
                    </div>
                  )}

                  {/* Show entries + Search */}
                  <div className="row w-100">
                    <div className="col-6">
                      <div className="dataTables_length">
                        <label className="d-inline-flex align-items-center">
                          Show&nbsp;
                          <select
                            className="custom-select custom-select-sm"
                            value={entriesPerPage}
                            onChange={(e) => {
                              setEntriesPerPage(Number(e.target.value))
                              setCurrentPage(1)
                            }}
                          >
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                          </select>
                          &nbsp;entries
                        </label>
                      </div>
                    </div>
                    <div className="col-6 text-right">
                      <div className="dataTables_filter text-md-right">
                        <label className="d-inline-flex align-items-center">
                          Search:
                          <input
                            type="search"
                            placeholder="Search..."
                            className="form-control ml-1 form-control"
                            value={tableSearch}
                            onChange={(e) => setTableSearch(e.target.value)}
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive mb-0 mt-3 report-table">
                    <div className="table no-footer table-responsive-sm">
                      <table
                        role="table"
                        aria-busy={loading}
                        aria-colcount={COLUMNS.length}
                        className="table b-table table-bordered"
                      >
                        <thead role="rowgroup">
                          <tr role="row">
                            {COLUMNS.map(([key, label]) => (
                              <th key={key} className={NUM_KEYS.has(key) ? 'text-right' : ''}>{label}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody role="rowgroup">
                          {loading ? (
                            <tr><td colSpan={COLUMNS.length} className="text-center my-2">Loading...</td></tr>
                          ) : filteredData.length === 0 ? (
                            <tr><td colSpan={COLUMNS.length} className="text-center mb-0">No data available in table</td></tr>
                          ) : (
                            filteredData.map((row, idx) => (
                              <tr key={row.user_id || idx}>
                                {COLUMNS.map(([key]) => (
                                  <td key={key} className={NUM_KEYS.has(key) ? 'text-right' : ''} style={NUM_KEYS.has(key) ? { color: 'green' } : undefined}>
                                    {cellValue(row, key)}
                                  </td>
                                ))}
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Pagination — original jaisa « ‹ 1 › », 1 page par bhi dikhta hai */}
                  <div className="row pt-3">
                    <div className="col">
                      <div className="dataTables_paginate paging_simple_numbers float-right">
                        <ul className="pagination pagination-rounded mb-0">
                          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" disabled={currentPage === 1} onClick={() => fetchData(1)}>«</button>
                          </li>
                          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" disabled={currentPage === 1} onClick={() => fetchData(currentPage - 1)}>‹</button>
                          </li>
                          {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter((p) => Math.abs(p - currentPage) <= 2 || p === 1 || p === totalPages)
                            .map((page, i, arr) => (
                              <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                {i > 0 && page - arr[i - 1] > 1 && <span className="page-link">…</span>}
                                <button className="page-link" onClick={() => fetchData(page)}>{page}</button>
                              </li>
                            ))}
                          <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" disabled={currentPage >= totalPages} onClick={() => fetchData(currentPage + 1)}>›</button>
                          </li>
                          <li className={`page-item ${currentPage >= totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" disabled={currentPage >= totalPages} onClick={() => fetchData(totalPages)}>»</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default UserRegisterDetail
